import { CLEARTRIP, FLYIN } from '@/src/constants/buildVariants'
import { VariantType } from '@/src/utils/buildUtils'

type FeatureFlags =
    | 'MULTI_CITY'
    | 'VISA'
    | 'FLIGHTS_HOTELS'
    | 'TRENDING_DESTINATIONS'
    | 'TRENDING_HOTELS'
    | 'OLD_SIGNIN_FLOW'
    | 'TRAVEL_LICENSE_INFO'
    | 'APP_DOWNLOAD_BANNER'
    | 'GIFT_VOUCHER'
    | 'SHUKRAN'
    | 'SMILES'
    | 'GOOGLE_SIGNIN'
    | 'EXPLORE_OTHER_LINKS'
    | 'TOP_DESTINATIONS'
    | 'TOP_COUNTRIES'
    | 'MULTI_DOMAIN_WALLET_BALANCE'
    | 'AIRSPACE_LATEST_UPDATES_BUTTON'
    | 'MULTI_BRAND_WALLET'
    | 'SIGNIN_WITH_EMAIL'
    | 'SIGNUP_ALLOWED'
    | 'SIGNIN_WITH_CT_TABS_ALLOWED'
    | 'TRIP_DETAILS_DIRECT_DOWNLOADS'
    | 'TRIP_DETAILS_INVOICE_TICKET_SECTION'
    | 'TRIP_DETAILS_SHOW_RESCHEDULE'
    | 'HOTEL_CROSS_SELL'
    | 'HOTEL_HOME_SHOWCASE'

export type Features = {
    [K in FeatureFlags]: boolean
}

export const featureConfig: Record<VariantType, Partial<Features>> = {
    [FLYIN]: {
        MULTI_CITY: true,
        FLIGHTS_HOTELS: true,
        TRENDING_DESTINATIONS: true,
        TRENDING_HOTELS: true,
        TRAVEL_LICENSE_INFO: true,
        APP_DOWNLOAD_BANNER: true,
        GOOGLE_SIGNIN: true,
        TOP_DESTINATIONS: true,
        TOP_COUNTRIES: true,
        MULTI_DOMAIN_WALLET_BALANCE: true,
        MULTI_BRAND_WALLET: true,
        GIFT_VOUCHER: true,
        SHUKRAN: true,
        SIGNIN_WITH_CT_TABS_ALLOWED: true,
        TRIP_DETAILS_DIRECT_DOWNLOADS: true,
        TRIP_DETAILS_INVOICE_TICKET_SECTION: true,
        HOTEL_CROSS_SELL: true,
        HOTEL_HOME_SHOWCASE: true
    },
    [CLEARTRIP]: {
        MULTI_CITY: true,
        VISA: true,
        OLD_SIGNIN_FLOW: true,
        GIFT_VOUCHER: true,
        SHUKRAN: true,
        SMILES: true,
        GOOGLE_SIGNIN: false,
        SIGNIN_WITH_EMAIL: true,
        SIGNUP_ALLOWED: false,
        EXPLORE_OTHER_LINKS: true,
        TOP_COUNTRIES: true,
        AIRSPACE_LATEST_UPDATES_BUTTON: true,
        TRIP_DETAILS_SHOW_RESCHEDULE: true,
        // Needs a Cleartrip SRP builder before this can be enabled — the cross-sell
        // currently emits Flyin hotel search URLs only.
        HOTEL_CROSS_SELL: false
    }
}
